module.exports = __webpack_public_path__ + "img/product_mb_new_03.de98fde.png";